var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "conecta-atenciones__base" },
    [
      _c(
        "div",
        { staticClass: "flex sm12 m12" },
        [
          _c(
            "FormFieldsContainer",
            [
              _c(
                "v-flex",
                {
                  attrs: {
                    sm12: "",
                    md12: "",
                    layout: "",
                    wrap: "",
                    "mt-4": "",
                    "mb-2": ""
                  }
                },
                [
                  _c(
                    "v-flex",
                    {
                      attrs: {
                        xs12: "",
                        sm8: "",
                        md8: "",
                        layout: "",
                        wrap: ""
                      }
                    },
                    [
                      _c(
                        "v-flex",
                        { attrs: { sm12: "", md12: "", layout: "" } },
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", sm6: "", md6: "", lg5: "" } },
                            [
                              _c("DatePicker", {
                                attrs: {
                                  label: "Fecha de Creación Desde",
                                  max: _vm.now
                                },
                                model: {
                                  value: _vm.objectParam.start_date,
                                  callback: function($$v) {
                                    _vm.$set(_vm.objectParam, "start_date", $$v)
                                  },
                                  expression: "objectParam.start_date"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", sm6: "", md6: "", lg5: "" } },
                            [
                              _c("DatePicker", {
                                attrs: {
                                  label: "Fecha de Creación Hasta",
                                  max: _vm.now
                                },
                                model: {
                                  value: _vm.objectParam.end_date,
                                  callback: function($$v) {
                                    _vm.$set(_vm.objectParam, "end_date", $$v)
                                  },
                                  expression: "objectParam.end_date"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", sm4: "", md4: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: "Folio",
                                  "item-text": "ndvnombre",
                                  "item-value": "ndvnombre",
                                  clearable: "",
                                  "prepend-icon": "home_repair_service"
                                },
                                on: { change: _vm.handleFilters },
                                model: {
                                  value: _vm.objectParam.folio,
                                  callback: function($$v) {
                                    _vm.$set(_vm.objectParam, "folio", $$v)
                                  },
                                  expression: "objectParam.folio"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", sm4: "", md4: "" } },
                            [
                              _c("v-autocomplete", {
                                attrs: {
                                  label: "Estado Certificado",
                                  items: _vm.filter,
                                  "item-text": "configlbl",
                                  "item-value": "configval",
                                  clearable: "",
                                  "prepend-icon": "domain_verification"
                                },
                                on: { change: _vm.handleFilters },
                                model: {
                                  value: _vm.objectParam.estado,
                                  callback: function($$v) {
                                    _vm.$set(_vm.objectParam, "estado", $$v)
                                  },
                                  expression: "objectParam.estado"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-flex",
                    {
                      attrs: {
                        xs12: "",
                        sm4: "",
                        md4: "",
                        layout: "",
                        "mt-2": ""
                      }
                    },
                    [
                      _c(
                        "v-btn",
                        { on: { click: _vm.handleSearchFilter } },
                        [
                          _c("v-icon", { attrs: { color: "#27488e" } }, [
                            _vm._v("search")
                          ]),
                          _vm._v("Filtrar\n          ")
                        ],
                        1
                      ),
                      _c(
                        "v-btn",
                        {
                          on: {
                            click: function($event) {
                              return _vm.reloadGrid({ clear: true })
                            }
                          }
                        },
                        [
                          _c("v-icon", { attrs: { color: "#27488e" } }, [
                            _vm._v("clear")
                          ]),
                          _vm._v("Limpiar\n          ")
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-flex",
                { attrs: { sm6: "", md6: "", layout: "" } },
                [
                  _c(
                    "v-flex",
                    { attrs: { xs4: "", sm4: "", md4: "" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          "append-icon": "search",
                          label: "Buscar Certificado...",
                          clearable: "",
                          outlined: ""
                        },
                        on: {
                          keyup: function($event) {
                            return _vm.gridApi.setQuickFilter(_vm.filtro)
                          },
                          "click:clear": function($event) {
                            return _vm.gridApi.setQuickFilter("")
                          }
                        },
                        model: {
                          value: _vm.filtro,
                          callback: function($$v) {
                            _vm.filtro = $$v
                          },
                          expression: "filtro"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c("v-divider"),
          _c(
            "v-flex",
            {
              attrs: {
                sm12: "",
                md12: "",
                layout: "",
                "justify-end": "",
                "align-center": "",
                "mt-3": "",
                "mb-4": ""
              }
            },
            [
              _c(
                "v-flex",
                { attrs: { xs12: "", sm12: "", md12: "" } },
                [
                  _c(
                    "v-flex",
                    {
                      staticStyle: { "text-align": "end" },
                      attrs: { xs4: "", sm12: "", md12: "" }
                    },
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "btn-grabar white--text",
                          on: {
                            click: function($event) {
                              return _vm.cambiar_estado_certificados(true)
                            }
                          }
                        },
                        [_vm._v("Activar Certificados")]
                      ),
                      _c(
                        "v-btn",
                        {
                          staticClass: "btn-grabar white--text",
                          on: {
                            click: function($event) {
                              return _vm.cambiar_estado_certificados(false)
                            }
                          }
                        },
                        [_vm._v("Desactivar Certificados")]
                      ),
                      _c(
                        "v-btn",
                        {
                          staticClass: "btn-grabar white--text",
                          on: { click: _vm.handleViewDetail }
                        },
                        [_vm._v("Emitir Certificado")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-flex",
            { attrs: { xs12: "", sm12: "", md12: "" } },
            [
              _c("MantenedorGridSinCodigo", {
                attrs: {
                  "grid-options": _vm.gridOptions,
                  mostrarAcciones: false,
                  funcionalidadId: 99999
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "Confirmation",
        {
          attrs: {
            show: _vm.dialogPopUp,
            titulo: _vm.confirmationData.title,
            mensaje: _vm.confirmationData.msgConfirmation,
            textoBtnSi: _vm.$t("Confirmar"),
            textoBtnNo: _vm.$t("Cancelar")
          },
          on: {
            modalConfirmationEmit: function($event) {
              return _vm.handleShowPopUp($event)
            }
          }
        },
        [
          _vm.mostrarHijo
            ? _c(
                "v-flex",
                { staticStyle: { padding: "16px" }, attrs: { xs12: "" } },
                [
                  _c("v-textarea", {
                    attrs: { label: "Motivo de la desactivación" },
                    model: {
                      value: _vm.motivo_desactivacion,
                      callback: function($$v) {
                        _vm.motivo_desactivacion = $$v
                      },
                      expression: "motivo_desactivacion"
                    }
                  })
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _vm.showPopUpReport
        ? _c("PopUpGeneratedReports", {
            attrs: { text: _vm.msgReport },
            on: { cerrar: _vm.handleCloseReport }
          })
        : _vm._e(),
      _vm.showModalViewDetail
        ? _c("CertificadosModalEmitir", {
            on: { cerrar: _vm.handleClosedModal }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }